import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import BookingsApi from "../state/bookings-api";
import { bookingsStore, configStore } from "../state/CommonState";
import submittedLogo from './status.booked.png'
import inprogressLogo from './status.ip.png'
import archivedLogo from './status.archived.png'
import percent95 from './95.percent.png'
import Newapi from "../state/new-api";
import Utils from "../util/Utils";

export default function ChartContracts(props) {
    useSnapshot(bookingsStore)
    useSnapshot(configStore)
    const [results, setResults] = useState({})
    const [conSummary, setConSummary] = useState({})
    const [toexpirecontracts, settoexpirecontracts] = useState([])
    let curDate = Utils.getCurrentDateString()
    let nextWeek = Utils.getCurrentDateString(Utils.addDays(new Date(), 7))

    const summarize = (data) => {
        let val = {
            'active': 0,
            'expired': 0,
            'toexpire': 0
        }
        if(data && data.length>0){
            data.filter(e => e.mode === 'CONTRACT').map(e => {
                let d = e.contract.validUpto
                if (d >= curDate) val['active'] += 1
                else val['expired'] += 1
            })
        }
        setResults(val)
    }
    const summarizeContracts = (data) => {
        let val = {
            'active': 0,
            'expired': 0,
            'toexpire': 0
        }
        let arr = []
        if(data && data.length>0){
            data.filter(e => e.mode === 'CONTRACT').map(e => {
                let d = e.validUpto
                if (d >= curDate) val['active'] += 1
                else val['expired'] += 1
                if (d >= curDate && d < nextWeek) {
                    val['toexpire'] += 1
                    arr.push(e)
                }
            })
        }
        settoexpirecontracts(arr)
        setConSummary(val)
    }
    useEffect(() => {
        BookingsApi.getAllBookings(summarize)
        Newapi.getContracts(summarizeContracts)
    }, [configStore.currentSelectedEntity, configStore.currentSelectedBranch])

    return (
        <>
            <div className="columns" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="column is-4">
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#00aa00' }}>Active</div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ff0000' }}>Expired</div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffaa00' }}>Expiring in 7 days</div>
                </div>
            </div>
            <div className="columns" style={{ textAlign: 'center', alignItems: 'center' }}>
                <div className="column is-4">
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#000', marginTop: '0px' }}>
                        {conSummary['active']}
                    </div>
                    <div style={{ color: 'brown', fontSize:'1.2rem' }}>
                        <span style={{ fontWeight: 'bold' }}>{results['active']}</span> Bookings
                    </div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#000', marginTop: '0px' }}>
                        {conSummary['expired']}
                    </div>
                    <div style={{ color: 'brown', fontSize:'1.2rem' }}>
                        <span style={{ fontWeight: 'bold' }}>{results['expired']}</span> Bookings
                    </div>
                </div>
                <div className="column is-4">
                    <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#000', marginTop: '0px' }}>
                        {conSummary['toexpire']}
                    </div>
                    <div style={{ color: '#3333ff' }}>
                        <a href={`${window.location.href}toexpirecontracts`} style={{ textDecoration: 'underline' }}
                            target="_blank" onClick={(e) => {
                                e.stopPropagation();
                            }}>Click here to view
                        </a>
                    </div>
                </div>
            </div>

        </>
    )
}